'use strict';

import axios from 'axios';

export default {
  checkRpps: function(rpps) {
    if(!rpps) {
      throw new Error('rpps empty.');
    }

    let params = {
      rpps: rpps
    };

    return axios({
      method: 'get',
      params: params,
      url: window.Routes.api.check_rpps,
    }).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      console.log(error.response);
      return Promise.reject(error.response.data);
    });
  },
  getRppsData: function(rpps, params) {
    if(!rpps) {
      throw new Error('rpps empty.');
    }

    if(!params) {
      let params = {};
    }

    params["rpps"] = rpps;

    return axios({
      method: 'get',
      params: params,
      url: window.Routes.api.get_rpps,
    }).then((response) => {
      return Promise.resolve(response.data);
    }).catch((error) => {
      console.log(error.response);
      return Promise.reject(error.response.data);
    });
  },
};
